<div *ngIf="announcement" aria-live="assertive" class="title-announcement" tabindex="-1" role="alert" [attr.aria-label]="announcement">
    {{ announcement }}
</div>
